import { Button, Col, Row } from "react-bootstrap";
import { formatDate } from "../../../../../../helpers";
import { IOrderItem } from "../../../../../models/IOrder";
import formatCurrency from "../../../../../utils/formatCurrency";
import { formatDeadline } from "../../../../../utils/formatDeadline";
import { formatProductType } from "../../../../../utils/formatProductType";
import { TableWrapper } from "./styles";
import { SecondaryButton } from "../../../styled";
import { MdOutlineAddCircle, MdOutlineAddCircleOutline } from "react-icons/md";

interface IOrderMaterialList {
	items: IOrderItem[];
	hasCoupons: boolean;
	onAddMaterial: () => void;
	onRemoveMaterial: (id: number) => void;
}

export const OrderMaterialList: React.FC<IOrderMaterialList> = ({
	items,
	hasCoupons = false,
	onAddMaterial,
	onRemoveMaterial
}) => {

	const handleMaterialList = () => {
		return items?.length > 0 ? (
			<TableWrapper>
				<table className="table">
					<thead>
						<tr>
							<th className="material-table-column-name">Nome</th>

							<th className="material-table-column-type">Tipo</th>
							{hasCoupons && (
								<th className="material-table-column-coupon">
									Cupom
								</th>
							)}
							<th className="material-table-column-deadline">
								Prazo
							</th>
							<th className="material-table-column-price">Preço</th>
							<th className="material-table-column-price">Ações</th>
						</tr>
					</thead>
					<tbody>
						{items.map((anItem) => {
							return (
								<tr key={anItem.product_id}>
									<td className="material-table-column-name">
										{anItem.description}
									</td>

									<td className="material-table-column-type">
										{formatProductType(anItem.product_type)}
									</td>
									{anItem.coupon?.length > 0 && (
										<td className="material-table-column-coupon">
											{anItem.coupon}
										</td>
									)}
									<td className="material-table-column-deadline">
										{formatDeadline(anItem.product_deadline)}
									</td>
									<td className="material-table-column-price">
										{formatCurrency(anItem.amount)}
									</td>
									<td className="material-table-column-actions">
										<Button variant="link" style={{ textDecoration: 'none', padding: 0 }} onClick={() => onRemoveMaterial(anItem.id)}>Remover</Button>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</TableWrapper>
		) : (
			<></>
		);
	}

	return (
		<>
			<div className="d-flex flex-column  w-100">
				<div className="d-flex flex-row justify-content-between">
					<div>
						<h3>Materiais</h3>
					</div>
					<div>
						<Button variant="outline-primary" style={{border: 0}} onClick={() => onAddMaterial()}>
							<MdOutlineAddCircleOutline size={20} style={{ verticalAlign: 'sub'}}/> Adicionar
						</Button>		
					</div>
				</div>
				<div className="">
					{handleMaterialList()}
				</div>
			</div>
		
			
		</>
	)
};
